import script from "./SignatureBox.vue?vue&type=script&setup=true&lang=js"
export * from "./SignatureBox.vue?vue&type=script&setup=true&lang=js"

import "./SignatureBox.vue?vue&type=style&index=0&id=1f07cee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f07cee2"]])

export default __exports__